import { useQuery } from '@tanstack/react-query';
import { getCasinoGameDetails } from '../../services/casinoService';
import { useMemo } from 'react';
import useCasinoFeedSocket from './useCasinoFeedSocket';
import { markCardBlinkBaseline } from '../../components/casino/cards/CardImg';

/**
 * Polls casino game data every 1s.
 * For array-based games (worli/matka) returns the full array.
 * For object-based games (teenpatti, dragon tiger) returns a single object.
 * `live: true` also takes the server's feed push (useCasinoFeedSocket), so the
 * timer and board move with every feed change instead of the poll's steps.
 * Opt-in per page (5Five so far).
 */
export default function useCasinoGame(gameType, { isArray = false, live = false } = {}) {
  // A table just opened: cards already face-up show directly, no blink (CardImg).
  useMemo(() => markCardBlinkBaseline(), [gameType]);
  useCasinoFeedSocket(gameType, ['casinoGame', gameType], live);
  return useQuery({
    queryKey: ['casinoGame', gameType],
    queryFn: () => getCasinoGameDetails(gameType),
    refetchInterval: 1000,
    select: (res) => {
      const data = res?.data?.data || res?.data || (isArray ? [] : null);
      if (isArray) return Array.isArray(data) ? data : [];
      return data && !Array.isArray(data) ? data : null;
    },
  });
}
